<template>
	<div class="f-ava">
		<img :src="'https://chat.iqquantum.com/avatar/' + userLogin + '?dc_'+new Date().getMilliseconds()" class="f-ava__img">
	</div>
</template>
<script>
export default {
    props:['userLogin']
}
</script>
